import React, { ReactNode, useState } from "react";
import classnames from "classnames";

import Header, { ActionOption } from "./components/Header";
import Body from "./components/Body";

import styles from "./CollapsableCard.module.scss";

interface Props {
  id: string;
  opened?: boolean;
  enableActions?: boolean;
  showHeader?: boolean;
  headerTitle?: string;
  bodyTitle?: string;
  rightTitle?: string;
  className?: string;
  children?: ReactNode;
  actions?: ActionOption[];
}

const CollapsableCard = ({
  id,
  headerTitle,
  enableActions,
  bodyTitle,
  rightTitle,
  opened = true,
  showHeader = true,
  className,
  children,
  actions,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(opened);

  return (
    <div className={classnames(styles.cardContainer, className)}>
      {showHeader && (
        <Header
          id={id}
          title={headerTitle}
          opened={isExpanded}
          enableActions={enableActions}
          onExpandClick={() => {
            setIsExpanded((prevIsExpanded) => !prevIsExpanded);
          }}
          options={actions}
        />
      )}
      <Body
        title={bodyTitle}
        opened={isExpanded}
        rightTitle={rightTitle}
        className={showHeader ? "" : styles.extraPadding}
      >
        {children}
      </Body>
    </div>
  );
};

export default CollapsableCard;
